import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { EMPTY, NONE } from "../../../configurations/Constants";
import { UPDATE_WELL_CONNECTION_CONFIRMATION } from "../../../configurations/MessageConstants";

const ConfirmationPopup = ({
  show,
  onHide,
  wellId,
  originalMeterId,
  meterId,
  originalAccountId,
  accountId,
  onConfirm,
  confirmBtnClick,
}) => {
  return (
    <Modal size="md" show={show} centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Update</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted">
          {UPDATE_WELL_CONNECTION_CONFIRMATION} <strong>{wellId}</strong>?
        </p>
        {originalMeterId !== meterId && (
          <p className="text-muted m-0">
            <strong>Meter ID:</strong>{" "}
            {originalMeterId === EMPTY ? NONE : originalMeterId} →{" "}
            {meterId === EMPTY ? NONE : meterId}
          </p>
        )}
        {originalAccountId !== accountId && (
          <p className="text-muted m-0">
            <strong>Account ID:</strong>{" "}
            {originalAccountId === EMPTY ? NONE : originalAccountId} →{" "}
            {accountId === EMPTY ? NONE : accountId}
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={confirmBtnClick}
        >
          {confirmBtnClick ? (
            <div>
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Confirming...
            </div>
          ) : (
            "Confirm"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationPopup;
